import { Spinner } from '@zappyrent/hundop';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import transferInstructionsAPI from '../../../services/api/transfer-instructions';
import { TransferInstructions } from '../../../shared/ts/transfer-instructions';
import {
  StyledButton,
  StyledError,
  StyledList,
  StyledListDescription,
  StyledListGroup,
  StyledListTitle,
  StyledSection,
  StyledTitle,
  StyledTitleWrapper,
} from './UserTransferInstructions.styles';

export const UserTransferInstructions = (): JSX.Element => {
  const { t } = useTranslation(['payments', 'common']);

  const [data, setData] = useState<TransferInstructions>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function getTransferInstructions() {
    try {
      setError('');
      setLoading(true);
      const response = await transferInstructionsAPI.getTransferInstructions();
      setData(response);
    } catch (e: unknown) {
      setError(t('transferInstructionsError'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <StyledSection>
      <StyledTitleWrapper>
        <StyledTitle>{t('transferInstructions')}</StyledTitle>
        {loading && <Spinner />}
      </StyledTitleWrapper>
      {data && Object.values(data).length > 0 ? (
        <StyledList>
          <StyledListGroup>
            <StyledListTitle>{t('accountHolderName')}</StyledListTitle>
            <StyledListDescription>
              {data.accountHolderName}
            </StyledListDescription>
          </StyledListGroup>
          <StyledListGroup>
            <StyledListTitle>Bic</StyledListTitle>
            <StyledListDescription>{data.bic}</StyledListDescription>
          </StyledListGroup>
          <StyledListGroup>
            <StyledListTitle>{t('country')}</StyledListTitle>
            <StyledListDescription>{data.country}</StyledListDescription>
          </StyledListGroup>
          <StyledListGroup>
            <StyledListTitle>IBAN</StyledListTitle>
            <StyledListDescription>{data.iban}</StyledListDescription>
          </StyledListGroup>
        </StyledList>
      ) : (
        <>
          <StyledButton onClick={getTransferInstructions} disabled={loading}>
            {t('common:load')}
          </StyledButton>
          {error && <StyledError role="alert">{error}</StyledError>}
        </>
      )}
    </StyledSection>
  );
};
